import { ref } from 'vue';

const getLocations = () => {
    const locations_error = ref(null);
    const locations = ref(null);

    const loadLocations = async () => {
      try {
        let data = await fetch("/api/locations");

        if (!data.ok) {
          throw Error("Can't load data");
        }

        locations.value = await data.json();

        // console.log('locations', locations.value);
      } catch (err) {
        locations_error.value = err.message;
      }
    };

    return { locations, locations_error, loadLocations};
}

export default getLocations;